import script from "./Parcels.vue?vue&type=script&setup=true&lang=js"
export * from "./Parcels.vue?vue&type=script&setup=true&lang=js"

import "./Parcels.vue?vue&type=style&index=0&id=19940b1b&lang=css"

const __exports__ = script;

export default __exports__